.actions {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
}
